module.exports = __webpack_public_path__ + "40cdf641d0060750e2b2c6dfdd6539b8.pdf";